export default __webpack_public_path__ + "static/media/A_05_01_bg_v04.051548d5.mp4";